<template>
  <div>
    <b-card>
      <template #default>
        <h3 class="text-center w-100">
          {{ $t('poster.post-page-title',{page:currentPage.name}) }}
        </h3>
      </template>
    </b-card>
    <b-row>
      <b-col
        md="7"
        sm="12"
      >
        <b-card>
          <poster-form />
        </b-card>

      </b-col>
      <b-col
        md="5"
        sm="12"
      >
        <b-card>
          <poster-preview />
        </b-card>

      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import PosterPreview from '@/views/owner-fb/poster/components/PosterPreview'
import PosterForm from '@/views/owner-fb/poster/components/PosterForm'
import FbPosterApi from '@/api/poster'

export default {
  name: 'AddPostPage',
  components: {
    PosterForm,
    PosterPreview,
    BCard,
    BRow,
    BCol,
  },
  data() {
    return {
      fetching: false,
    }
  },
  computed: {
    ...mapGetters({
      currentPage: 'pages/currentPage',
    }),
    idEdit() {
      return !!this.$route.params.id
    },
  },
  async  mounted() {
    if (this.idEdit) {
      await this.fetchPost()
    }
  },
  methods: {
    async fetchPost() {
      this.fetching = true
      await FbPosterApi.fetchPost(this.currentPage.id, this.$route.params.id).then(res => {
        this.$store.commit('poster/SET_FORM', {
          message: res.post?.full_message,
          id: res.post?.id,
          files: res.post?.files ?? [],
          reply_message: res.post?.reply_message?.text ?? '',
          schedule_type: (res.post?.is_posted ?? false) ? 'now' : 'later',
          schedule_time: res.post?.schedule_at ?? [],
          template_id: res.post?.reply?.id,
        })
      }).finally(() => { this.fetching = false })
    },
  },

}
</script>
